export default {
	servicesWithIntegration: state =>
		(state.viewModel.transportServices || []).filter(
			ts => ts.integrationBooking != null
		)
};
